import { Button, Dialog } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import styles from "styles/layout/ModalWrapper.module.scss";

const ModalWrapper = (props) => {
  const {
    open,
    onClose,
    children,
    handleClose,
    defaultclass,
    text,
    modalType = "info",
    onClickClose,
    className,
    noOnClose
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={className}
      // className={styles.modalWrapper}
      // className={defaultclass}
    >
      {!noOnClose && <div className={styles.modalHeader}>
        <Button
          className="cross_btn"
          onClick={(e) => {
            handleClose();
            // onClickClose(); // for popover close when close modal
          }}
        >
          <CloseIcon />
        </Button>
      </div>}

      {children}
    </Dialog>
  );
};

export default React.memo(ModalWrapper);
